import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewRef,LOCALE_ID,EventEmitter,Output } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FormControl } from '@angular/forms'
import { MatDrawer, MatSnackBar } from '@angular/material'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ONE_MB_IN_BYTES } from '../../../../../constants/FileSize'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, CommunicationService, StateService,TiersService } from '../../../../../services'

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { Subject,Observable } from 'rxjs'
import { debounceTime, distinctUntilChanged ,startWith,map} from 'rxjs/operators'

const KEY = 'message-dialog'

@Component({
	selector: 'atyl-message-dialog',
	templateUrl: './message-dialog.component.html',
	styleUrls: ['./message-dialog.component.scss'],
  	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'views/partials/content/general/message',
	key: KEY,
})
export class MessageDialogComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY) strings: any

	@ViewChild('drawer', { static: false }) drawer: MatDrawer
	
	loading:boolean=false;
	
	type: string='courrier';
	
	dossier:any;
     
    points:any=[];
    
	object:any;
	 
	currentTab: any;
	
	configHTML: any = {
		    placeholder: 'Description',
	       /* height: '15vh',*/
	        width: '100%',
	        toolbar: [
	            
	            ['style', ['bold', 'italic', 'underline']],
	            ['para', ['ul', 'ol', 'paragraph', 'height']],
	            ['insert', ['table']],
	            
	        ],
	        buttons: {
	           
	          }
	 };
	 rows:number=10;
	 smsMaxLength:number=160;
	 
    @Output() lengthNote: EventEmitter<number> = new EventEmitter<number>();
    
	clickTabSubject: Subject<any> = new Subject<any>()
     
	
	tiersCtrl = new FormControl();
	tiersList: any = [];
	
	subjectInput:any;
	descriptionInput:any;
	destinaraireInput:any[]=[];
	pointInput:any;
	dateSendInput:any;
	isimmediate:boolean=false;
	contactCode:string='EMAIL';
	
	attachment:boolean=false;
	
	issend:boolean=true;
	disabledField:boolean=true;
	errors:string[]=[];
	
	constructor(
		public dialogRef: MatDialogRef<MessageDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public stateService: StateService,			
		changeDetectorRef: ChangeDetectorRef,
		private communicationService: CommunicationService,
		private tiersService: TiersService,
		dialogService: DialogService,
		 router: Router,
		private activatedRoute: ActivatedRoute,
		private _snackBar: MatSnackBar,
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		this._initTiersSearch();
		
		if (this.data.type!=undefined && this.data.type ) {
			this.type = this.data.type;
		}
		
		if (this.data.dossier!=undefined && this.data.dossier ) {
					this.dossier = this.data.dossier
		}
		if (this.data.object!=undefined && this.data.object ) {
							this.object = this.data.object		
		}
		
		if (this.data.points!=undefined && this.data.points ) {
			this.points = this.data.points;
			this.filldata();
		}
		
		
		
	}

	detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
	filldata(index:number=0) {
		
		if (this.points[index]!==undefined) {
			let point:any=this.points[index];
			this.pointInput=point;
			if (point.description!=undefined)
				this.descriptionInput=point.description;
			if (point.sujet!=undefined)
				this.subjectInput=point.sujet;
			if (point.attachment!=undefined)
				this.attachment=point.attachment;
			if (point.dateenvoi!=undefined)
				this.dateSendInput=point.dateenvoi;
			if (point.immediate!=undefined)
				this.isimmediate=point.immediate;
			if (point.contact!=undefined && point.contact.code!=undefined)
				this.contactCode=point.contact.code;
			
			this.destinaraireInput=[];
			this.issend=false;
			this.disabledField=true;
			let _opts:any={
						   
					   }
			console.log("MessageDialogComponent before loaded",this.contactCode,point.ID,this.object,this.object,this.type,_opts);		   
			this.communicationService.getMessageData(point.ID,this.object,this.type,_opts).subscribe(
						   (res: JSONRpcResponse) => {
								console.log("MessageDialogComponent loaded",res);
								if (res.result 
									&& res.result!=undefined
								) {
									let mes:any=res.result;
									if (mes.description!=undefined)
										this.descriptionInput=mes.description;
									if (mes.sujet!=undefined)
										this.subjectInput=mes.sujet;
									if (mes.sujet!=undefined)
										this.subjectInput=mes.sujet;
									if (mes.destinataires!=undefined)
									 	this.destinaraireInput=mes.destinataires;
									if (mes.dateenvoi!=undefined)
										this.dateSendInput=mes.dateenvoi;
									if (mes.immediate!=undefined)
										this.isimmediate=mes.immediate;
									this.issend=true;
									this.disabledField=false;
									this.tiersCtrl.enable({onlySelf:true});
									this.detectChanges();
								}
									
							}
			);
			
		}
	}
	
	
	tabChange(event: any) {
	       // let tab = event.tab.textLabel;
	       let tab = event.label

	       this.currentTab = tab
	       console.log("tabChange",tab,event);
		   
		   if (event.code!=undefined ) {
			 this.filldata(event.code);
		   }
		   
	}	   
	closeDialog(event: any) {
	    this.dialogRef.close(event)
	  }
	  
	checkContent(event: any) {
	  	let check:boolean=true;
		this.errors=[];
		console.log("MessageDialogComponent checkContent",this.pointInput.email,this.subjectInput,this.descriptionInput,)
		if (this.descriptionInput.length==0
			|| this.descriptionInput=="&nbsp;"
			|| this.descriptionInput.toLowerCase()=="<br>"
			|| this.descriptionInput.toLowerCase()=="<br/>"
		) {
			check=false;
			this.errors.push(this.strings.dialog.errors.noDescrition);
		}
		
		
		if (this.pointInput!=undefined 
			&& this.pointInput.email 
			&& this.subjectInput.length==0) {
			check=false;
			this.errors.push(this.strings.dialog.errors.noObject);
		}
		if (!check) {
			this.issend=false;
			
		} else
			this.issend=true;
		return check;
	 }
	 
	sendMessage(event:any) {
		console.log("MessageDialogComponent before sendMessage",this.pointInput,this.destinaraireInput,this.type,this.object);	
		if (this.pointInput!=undefined && this.pointInput.ID!=undefined 
			&& this.destinaraireInput.length>0	
			&& this.type!=undefined
			&& this.object!=undefined
		 ) {
			this.issend=false;
			this.loading=true;
			let sujet:string=this.subjectInput;
			if (this.pointInput!=undefined 
						&& this.pointInput.sms)
				sujet=null;	 
			let _opts:any={
				destinataires:this.destinaraireInput,
				sujet: sujet,
				description: this.descriptionInput,
				dateenvoie:this.dateSendInput,
				immediate:this.isimmediate,
			};
			
			this.communicationService.setMessage(this.pointInput.ID,this.object,this.type,_opts).subscribe(
				(res: JSONRpcResponse) => {
					this.loading=false;
					if (res.result)
						this._snackBar.open('Message envoyé', 'X', {
						           duration: 2000,
						           panelClass: 'snackbar-success'
						         });
				     else 
						 this._snackBar.open('Message non envoyé', 'X', {
	 						           duration: 2000,
	 						           panelClass: 'snackbar-danger'
						  });
					this.closeDialog(true);
				});
			
			
		}
	}
	
	
	_initTiersSearch(){
			this.tiersCtrl.disable({onlySelf:true});
				
			this.tiersCtrl.valueChanges.pipe(
				debounceTime(400),
				distinctUntilChanged()
			).subscribe(term => {
				console.log('tiersList serach ', term);
				let type:string[]=["ENFANT","USAGER"];
				let _opts={
					type: type
				}
				
				if (term!=undefined && term && term.length>0)
					this.tiersService.searchTiersForVisite(term,_opts).subscribe((res: JSONRpcResponse) => {
							if (res.result )
							   this.tiersList = res.result;
							
					})
			})
    }
	
	displayAutoTiers(value: any) {
			console.log("displayAutoTiers",value)
			let label:any="";
			/*let stop:boolean=false;
			this.consultationsList.forEach((c: any) => {
					if (!stop && c.ID==value.ID ){
						stop=true;
						
					    label= this._getConsultationLabel(c);
					}
				});
			*/
			return this._displaySelectedTier(value);  
	 }
	
	selectMember(tiers: any) { 
			console.log('selectMember destinataire:',tiers)
			
			
			let dest:any= {
						principal: 0,
						destinataire: null,
						optin: 0,
						tiers: tiers,
					}	
					
				if (tiers.contacts!=undefined
									&& tiers.contacts[this.contactCode]!=undefined) {
					dest.destinataire=tiers.contacts[this.contactCode];	
				}
				if (tiers.contactsOptin!=undefined
											&& tiers.contactsOptin[this.contactCode]!=undefined)
						dest.optin=(tiers.contactsOptin[this.contactCode]=="oui") ? 1 : 0;				
				
				this.destinaraireInput.push(dest);
				
				this.detectChanges();	
			
	}
	
	selectedListTiers(tiers: any) { 
				console.log('selectedListTiers destinataire:',tiers)
				
		
	}
	
	_displaySelectedTier(tiers:any,ishtml:boolean=true) {
		
		let lbs:string[]=[];
		
		if (tiers==undefined || !tiers)
			return undefined;
		
		if (tiers.PRENOM!=undefined)
			lbs.push(tiers.PRENOM);
		if (tiers.NOM!=undefined)
			lbs.push(tiers.NOM);
		if (tiers.NOM!=undefined)
			lbs.push(tiers.NOM);
		
		if (tiers.DATENAISSANCE!=undefined
			&& tiers.DATENAISSANCE) {
			let dt:any = moment(tiers.DATENAISSANCE);
			if (dt instanceof moment) {
				lbs.push(moment(tiers.DATENAISSANCE).format('DD/MM/YYYY'));
				
			}
	    }
		if (tiers.contacts!=undefined
					&& tiers.contacts[this.contactCode]!=undefined) {
				lbs.push(tiers.contacts[this.contactCode]);	
		}
		if ( tiers.contactsOptin!=undefined
							&& tiers.contactsOptin[this.contactCode]!=undefined
						&&	tiers.contactsOptin[this.contactCode]=="oui"
						) {
				lbs.push((ishtml)? 
				'<i class="la la-sms text-success" title="Autorisation envoi (SMS,Email)"></i>'
				 : 'Autorisation envoi' );
					
			
		}
		
		return (ishtml) ? lbs.join("&nbsp;"): lbs.join(" ");
	}
	
	_displaySelectedTierNoHtml(tiers:any) {
			
			
			return this._displaySelectedTier(tiers,false);
	}
	
	removeMember(tiers:any,index:number) {
		console.log('remove destinataire:',tiers,index);
		
		if (index >= 0) {
				this.destinaraireInput.splice(index, 1)
				this.detectChanges();	
		}
	}
	
	
	
}
